import dayjs from "dayjs";
import { Facebook, Instagram, Twitter } from "react-feather";
import { Link } from "react-router-dom";

const ModernMinimalTemplate = () => {

    const services = [
        {
            title: "Air Freight",
            description: "Global air freight solutions.",
            icon: "✈️",
        },
        {
            title: "Sea Freight",
            description: "Reliable ocean shipping.",
            icon: "🚢",
        },
        {
            title: "Road Transport",
            description: "Efficient road transportation.",
            icon: "🚚",
        },
        {
            title: "Warehousing",
            description: "Smart warehousing solutions.",
            icon: "🏭",
        },
    ];

    const features = [
        "On-time delivery guarantee",
        "Real-time shipment tracking",
        "24/7 customer support",
        "Secure and flexible solutions",
    ];

    return (<div style={{ fontFamily: "Arial, sans-serif", background: "#ffffff", color: "#111827", minHeight: "100vh" }}>
        <div style={{ maxWidth: "1450px", margin: "0 auto" }}>
            <header style={{ padding: "22px 50px", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #f1f1f1", position: "sticky", top: 0, zIndex: 999, background: "#ffffff" }}>
                <div style={{ width: '200px', height: 'auto' }}>
                    <img src="/images/logo.svg" alt="logo" />
                </div>

                <nav style={{ display: "flex", gap: "35px", alignItems: "center" }}>
                    <Link to={"/sign-in"} style={navLink}>Sign In</Link>
                    <Link to={"/track-booking"} style={navLink}>Track</Link>
                    <button style={{ background: "#6d4cff", color: "#fff", border: "none", padding: "14px 28px", borderRadius: "10px", cursor: "pointer", fontSize: "16px", fontWeight: "bold" }}>+1 234 567 8900</button>
                </nav>
            </header>

            <section style={{ padding: "90px 60px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "40px", alignItems: "center" }}>
                <div>
                    <p style={{ color: "#6d4cff", fontWeight: "bold", marginBottom: "20px", fontSize: "18px" }}>Worldwide Logistics</p>
                    <h1 style={{ fontSize: "76px", lineHeight: "88px", marginBottom: "25px" }}>Moving Business<br /><span style={{ color: "#6d4cff" }}>Forward</span></h1>
                    <p style={{ fontSize: "22px", lineHeight: "38px", color: "#555", maxWidth: "600px" }}>Smart logistics solutions for modern businesses. Simple, efficient and
                        reliable.</p>
                </div>

                <div>
                    <img src="/images/template3-banner.png" alt="truck" style={{ width: "100%" }} />
                </div>
            </section>

            <section style={{ padding: "70px 60px" }}>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))", gap: "25px" }}>
                    {services.map((item, index) => (<div key={index} style={{ border: "1px solid #ececec", padding: "40px 30px", textAlign: "center" }}>
                        <div style={{ fontSize: "55px", marginBottom: "20px", color: "#6d4cff" }}>{item.icon}</div>
                        <h3 style={{ fontSize: "28px", marginBottom: "15px" }}>{item.title}</h3>
                        <p style={{ color: "#666", fontSize: "18px", lineHeight: "30px" }}>{item.description}</p>
                    </div>))}
                </div>
            </section>

            <section style={{ padding: "90px 60px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "50px", alignItems: "center" }}>
                <div>
                    <h2 style={{ fontSize: "52px", marginBottom: "35px" }}>Why Choose Us</h2>
                    <div style={{ display: "flex", flexDirection: "column", gap: "22px" }}>
                        {features.map((item, index) => (<div key={index} style={{ display: "flex", alignItems: "center", gap: "15px", fontSize: "22px" }}>
                            <span style={{ color: "#6d4cff", fontSize: "26px" }}>✔</span>
                            {item}
                        </div>))}
                    </div>
                </div>

                <div>
                    <img src="/images/template3-image.png" alt="warehouse" style={{ width: "100%" }} />
                </div>
            </section>


        </div>

        <footer style={{ borderTop: "1px solid #ececec", background: "#f1f1f1", padding: "60px 285px 30px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "40px" }}>
                <div>
                    <h3 style={{ marginBottom: "20px", }}>Contact Info</h3>
                    <p>📞 +1 234 567 9900</p>
                    <p>✉️ info@logix.com</p>
                    <p>📍 123 Logistics Way, New York, USA</p>
                </div>

                <div>
                    <h3 style={{ marginBottom: "20px" }}>Follow Us</h3>
                    <div style={{ display: "flex", gap: "20px" }}>
                        <a href="#" style={socialIcon}>
                            <Facebook />
                        </a>
                        <a href="#" style={socialIcon}>
                            <Instagram />
                        </a>
                        <a href="#" style={socialIcon}>
                            <Twitter />
                        </a>
                    </div>
                </div>
            </div>

            <div style={{ marginTop: "50px", borderTop: "1px solid #ececec", paddingTop: "20px", textAlign: "center", color: "#777" }}>© {dayjs().format('YYYY')} Ezy Freight Logistics, All Right Reserved.</div>
        </footer>
    </div>);
};

const navLink = {
    textDecoration: "none",
    color: "#111827",
    fontSize: "16px",
    fontWeight: "500",
};

const socialIcon = {
    color: "#000",
    textDecoration: "none",
    fontSize: "18px",
};

export default ModernMinimalTemplate;